import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { marginLeft } from 'utils';

export const StyledFilterItemWrapper = styled('div')(
  ({ theme }) => css`
    .filter-item {
      ${marginLeft('8px')}
      min-width: 230px;
      box-sizing: border-box;
      margin-bottom: 4px;
      padding: 4px 20px;
      border-radius: 8px;
      cursor: pointer;
      border: 1px solid transparent;
      position: relative;

      &.has-filter {
        &::after {
          position: absolute;
          background-color: #008bf8;
          width: 6px;
          height: 6px;
          right: 8px;
          top: 13px;
          border-radius: 50%;
          content: '';
        }
      }

      .title {
        display: flex;
        justify-content: space-between;
        color: #3c607a;
        font-size: ${theme.typography.subtitle2.fontSize};
        font-weight: ${theme.typography.subtitle2.fontWeight};
        line-height: ${theme.typography.subtitle2.lineHeight};

        .icon {
          color: #3c607a;
          font-weight: 500;
        }
      }

      .sub-title {
        color: #9caebb;
        font-size: ${theme.typography.overline.fontSize};
        font-weight: ${theme.typography.overline.fontWeight};
        line-height: ${theme.typography.overline.lineHeight};
      }

      &.selected {
        border: 1px solid ${theme.palette.primary.light};
        background: rgba(25, 157, 163, 0.08);
      }
    }
  `
);
